<template>
  <el-dialog :title="progressTitle" @close="cancel" :visible="innerVisiable" width="370px" append-to-body :close-on-click-modal="false" :show-close="showClose">
    <div>
      {{this.progressHeadContent}}
    </div>
    <el-progress :text-inside="true" :stroke-width="18" :percentage="progressNum"></el-progress>
    <el-col :span="24" class="pull-left text-center" style="padding-top: 20px;">
      <span class="dialog-footer" v-if="showClose">
        <el-button size="small" type="primary" @click="cancel">取 消</el-button>
      </span>
    </el-col>
    <div class="clearfix"></div>
  </el-dialog>
</template>

<script>
export default {
  name: 'Progress',
  data() {
    return {
      progressHeadContent: '正在...',
      progressNum: 0,
      innerVisiable: false
    }
  },
  props: {
    progressTitle: {
      type: String,
      default() {
        return '默认标题'
      }
    },
    progressTaskId: {
      type: String,
      required: true
    },
    progressFinish: {
      type: Function,
      default() {
        return function () {
          console.log('进程结束')
        }
      }
    },
    showClose: {
      type: Boolean,
      default() {
        return true
      }
    }
  },
  methods: {
    startProgress () {
      const self = this
      this.innerVisiable = true
      this.startTimer = setInterval(() => {
        const params = {
          taskId: self.progressTaskId
        }
        self.$http.post(window.$envUtils('VUE_APP_BP_SERVICE') + '/infinite/progress/getPro', { params }).then(res => {
          if (res && res.data) {
            if (res.data.currentCount && res.data.totalCount && res.data.totalCount !== 0) {
              self.progressNum = Math.ceil(res.data.currentCount * 100 / res.data.totalCount)
            } else {
              self.progressNum = 0
            }
            self.progressHeadContent = res.data.message
            if (res.data.finished) {
              self.innerVisiable = false
              self.progressNum = 0
              clearInterval(self.startTimer)
              self.progressFinish(res.data)
            }
          } else {
            self.$message.error('返回参数错误')
          }
        }).catch(rees => {
          self.$message.error('请求出错')
        })
      }, 1000)
    },
    cancel () {
      const self = this
      const params = {
        taskId: this.progressTaskId
      }
      this.$http.post(window.$envUtils('VUE_APP_BP_SERVICE') + '/infinite/progress/cancelPro', { params }).then(res => {
        self.innerVisiable = false
        self.progressNum = 0
        clearInterval(self.startTimer)
      }).catch(rees => {
        self.$message.error('取消进程失败')
      })
    }
  }
}
</script>
